'use client';

import { c as _c } from "react/compiler-runtime";
import type { SpartanProductFeatureCopyListProps } from '@/app/lcv/components/sections/spartan/products/shared/feature-carousel/feature-copy-list/types';
import { useContentSwipe } from '@/app/lcv/components/sections/spartan/products/shared/feature-carousel/feature-copy-list/useContentSwipe';
import styles from '@/app/lcv/components/sections/spartan/products/shared/feature-carousel/styles.module.css';
import { getSpartanRevealElementProps, SPARTAN_REVEAL_PRESET, SPARTAN_REVEAL_ROLE } from '@/app/lcv/components/sections/spartan/products/shared/reveal';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
export const SpartanProductFeatureCopyList = t0 => {
  const $ = _c(21);
  const {
    features,
    tracking,
    selectedIndex,
    tone,
    onSelectPrevious,
    onSelectNext
  } = t0;
  let t1;
  if ($[0] !== onSelectNext || $[1] !== onSelectPrevious) {
    t1 = {
      onSelectPrevious,
      onSelectNext
    };
    $[0] = onSelectNext;
    $[1] = onSelectPrevious;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    handlePointerDown,
    handlePointerUp,
    handlePointerCancel
  } = useContentSwipe(t1);
  const t2 = tone === "light" ? "text-gray-900 lg:text-white" : "text-white";
  let t3;
  if ($[3] !== t2) {
    t3 = cn("lg:aspect-16-9 grid touch-pan-y pt-4 md:pt-6 lg:pointer-events-none lg:absolute lg:inset-x-0 lg:top-0 lg:z-2 lg:p-8", t2);
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = getSpartanRevealElementProps({
      preset: SPARTAN_REVEAL_PRESET.gallery,
      role: SPARTAN_REVEAL_ROLE.galleryCopy
    });
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== features || $[7] !== selectedIndex || $[8] !== tone || $[9] !== tracking) {
    let t6;
    if ($[11] !== selectedIndex || $[12] !== tone || $[13] !== tracking) {
      t6 = (feature, index) => {
        const isSelected = index === selectedIndex;
        return <div key={[feature.title, index].join("-")} className={cn(styles.copyItem, "col-start-1 row-start-1 lg:self-end", !isSelected && "pointer-events-none select-none")} data-active={isSelected ? "true" : undefined} aria-hidden={!isSelected}><div className="where-span:text-inline-wrap where-small:block where-small:text-caption mx-auto max-w-176 space-y-1 text-center lg:space-y-2"><h3 className={cn("font-noto-bold text-sub-h2", tone === "light" ? "text-gray-900 lg:text-white" : "text-white")} dangerouslySetInnerHTML={{
              __html: feature.title
            }} {...createDataAttributes({
              test: tracking.featureTitle(index)
            })} />{!!feature.description && <div className={cn("text-body-1 space-y-1 lg:space-y-2", tone === "light" ? "text-gray-700 lg:text-white/90" : "text-white/90")} dangerouslySetInnerHTML={{
              __html: feature.description
            }} {...createDataAttributes({
              test: tracking.featureDescription(index)
            })} />}</div></div>;
      };
      $[11] = selectedIndex;
      $[12] = tone;
      $[13] = tracking;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    t5 = features.map(t6);
    $[6] = features;
    $[7] = selectedIndex;
    $[8] = tone;
    $[9] = tracking;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[15] !== handlePointerCancel || $[16] !== handlePointerDown || $[17] !== handlePointerUp || $[18] !== t3 || $[19] !== t5) {
    t6 = <div className={t3} onPointerDown={handlePointerDown} onPointerUp={handlePointerUp} onPointerCancel={handlePointerCancel} {...t4}>{t5}</div>;
    $[15] = handlePointerCancel;
    $[16] = handlePointerDown;
    $[17] = handlePointerUp;
    $[18] = t3;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
};